// FranceIdentiteSSO.tsx

import * as React from "react";
import FranceIdentiteImg from "../../assets/img/france-identite.png";
import { loginWithFranceIdentite } from "features/auth";

type Props = {
  text?: string
};
export const FranceIdentiteSso = ({ text= "ou connectez-vous avec :" }: Props) => {
  return (
    <div>
      {(!+(process.env?.REACT_APP_FOR_PARTNER_ONLY || 0)) && (!!+(process.env.REACT_APP_FOR_ENABLE_SSO||0)) && (
        <div className="mt-4 d-flex flex-column gap-05 align-items-center justify-content-center w-100">
          <div className={"text-sm"}>{text}</div>
          <div>
            <img
              onClick={async () => await loginWithFranceIdentite()}
              src={FranceIdentiteImg}
              alt="France identité"
              width={80}
              className={"pointer"}
            />
          </div>
        </div>
      )}
    </div>
  );
};
